"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
const RecordingCardDetails_1 = __importDefault(require("@Components/Cards/WorkDetailCards/RecordingCard/RecordingCardDetails"));
const RecordingCardHeader_1 = __importDefault(require("@Components/Cards/WorkDetailCards/RecordingCard/RecordingCardHeader"));
const RecordingCard = (props) => {
    const { data, removeFunction, editFunction } = props;
    const [detailsIsOpen, setDetailsIsOpen] = (0, react_1.useState)(false);
    const title = 'title' in data ? data.title : data.recordingTitle;
    const artistName = 'artistName' in data ? data.artistName : data.recordingDisplayArtistName;
    const isrc = data.isrc;
    const duration = data.duration;
    const label = data.label;
    const releaseDate = data.releaseDate;
    return (react_1.default.createElement("div", { className: 'recording-card' },
        react_1.default.createElement(RecordingCardHeader_1.default, { data: data, removeFunction: removeFunction, editFunction: editFunction, title: title }),
        react_1.default.createElement("div", { className: 'content' },
            react_1.default.createElement("p", { className: 'small' },
                react_1.default.createElement("span", { className: `${(0, fields_validators_1.isrcInvalidCheck)(isrc) ? 'red-text bold' : ''}` }, "ISRC:\u00A0"),
                react_1.default.createElement("strong", null, isrc || '')),
            react_1.default.createElement("p", { className: `small ${(0, fields_validators_1.artistNameInvalidCheck)(artistName) ? 'red-text bold' : ''}` }, "Artist:"),
            react_1.default.createElement("div", { className: 'row-container' },
                react_1.default.createElement("p", { className: 'bold' }, artistName ? (0, string_escape_newlines_1.stringEscapeNewlines)(artistName) : ''),
                react_1.default.createElement("p", { onClick: () => setDetailsIsOpen(!detailsIsOpen), className: 'details small bold' },
                    "More Info ",
                    detailsIsOpen ? '-' : '+')),
            detailsIsOpen && react_1.default.createElement(RecordingCardDetails_1.default, { duration: duration, label: label, releaseDate: releaseDate }))));
};
exports.default = (0, mobx_react_1.observer)(RecordingCard);
